<template>
  <v-container class="categories">
    <v-row>
      <v-col>
        <h2 class="text-center main-color main-title">
          {{ $t("Categories") }}
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="categories-btns text-center">
          <v-btn
            v-for="(cat, index) in categories"
            :class="cat.id == catId ? 'active' : ''"
            :key="index"
            color="#F2F3F6"
            :to="'/market/categories/' + cat.id"
            >{{ cat.name }}</v-btn
          >
          <!-- @click="getProductsUnderCategory(cat.id)" -->
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="4"
        md="3"
        v-for="(product, index) in products"
        :key="index"
      >
        <v-card class="ma-4" height="300" width="300" color="grey">
          <v-img
            :src="product.thumb != '' ? product.thumb : productPlaceholder"
            class="white--text align-end addToWishlist"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="300px"
            @click="viewProduct(product.id)"
          >
            <div class="product-info">
              <p
                class="text-center card-title addToWishlist"
                @click="viewProduct(product.id)"
              >
                {{ product.name }}
              </p>

              <v-row class="mx-0 text-center">
                <v-col cols="2" sm="2" @click.stop="addToCart(product.id)">
                  <v-icon color="#ffffff">add_shopping_cart</v-icon>
                </v-col>
                <v-col cols="8" sm="8">
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                  <v-icon color="#FDCD25">star_rate</v-icon>
                </v-col>
                <v-col
                  cols="2"
                  sm="2"
                  v-if="isLoggedIn"
                  @click.stop="addToWishList(product.id)"
                >
                  <v-icon color="#ffffff" class="addToWishlist"
                    >favorite_border</v-icon
                  >
                </v-col>
              </v-row>
            </div>
          </v-img>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="text-center">
          <v-pagination
            v-model="page"
            color="#13a8b1"
            :length="total"
            v-if="total > 1"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <Snack ref="snack"></Snack>
  </v-container>
</template>

<script>
export default {
  name: "Categories",
  data() {
    return {
      productPlaceholder: require("../../assets/images/product.png"),
      page: 1,
      categories: [],
      products: [],
      catId: "",
      total: 6,
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false
    };
  },
  watch: {
    page: {
      handler() {
        this.getProductsUnderCategory();
      }
    },
    "$route.params": {
      handler() {
        this.catId = this.$router.currentRoute.params.id;
        this.getProductsUnderCategory(this.catId);
      }
    }
  },
  methods: {
    getCategories() {
      this.$http.get(this.getApiUrl + "/market/categories").then(response => {
        if (response.data.status.error == false) {
          this.categories = response.data.data;
        }
      });
    },

    getProductsUnderCategory(catId = null) {
      this.catId = catId;
      let id = "";
      if (this.catId) {
        id = this.catId;
      } else {
        id = "";
      }
      this.$http
        .get(
          this.getApiUrl +
            "/market/categories/products/" +
            id +
            "?page=" +
            this.page
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.products = response.data.data.products.data;
            this.page = response.data.data.products.current_page;
            this.total = response.data.data.products.last_page;
          }
        });
    },
    addToWishList(product_id) {
      this.$http
        .get(this.getApiUrl + "/market/wishlist/add/" + product_id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.$refs.snack.sendSuccessAlert(response.data.status.message);
          } else {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          }
        });
    },
    addToCart(id) {
      this.$http
        .post(
          this.getApiUrl + "/market/cart/add",
          {
            product_id: id,
            cartID:
              localStorage.cartID && localStorage.cartID != undefined
                ? localStorage.cartID
                : ""
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.$refs.snack.sendSuccessAlert(response.data.status.message);
            if (response.data.data.cartID != undefined) {
              localStorage.cartID = response.data.data.cartID;
            }
            this.$bus.$emit("cartChanged");
          } else {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          }
        });
    },
    viewProduct(id) {
      this.$router.push({ path: "/market/product/" + id });
    }
  },
  mounted() {
    this.catId = this.$router.currentRoute.params.id;
    this.getCategories();
    this.getProductsUnderCategory(this.catId);
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.categories {
  .main-title {
    font-size: 2rem;
  }

  .categories-btns {
    .v-btn {
      border: 1px solid #ddd;
      margin: 5px 5px;
    }
  }

  .v-card {
    .card-title {
      margin-bottom: 0 !important;
    }
  }
}

.active {
  background-color: $main-color !important;
  color: #ffffff;
}
.addToWishlist {
  cursor: pointer;
}
</style>
